import React from "react";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Select from "../../../../common/StyledSelect";
import ErrorIcon from "@material-ui/icons/Error";
import Cancel from "@material-ui/icons/Cancel";
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import { isEqual } from "lodash/lang";
import notificationConstant from "./constants";
import { ToggleRenderer } from "../../../../dataGrid/cellRenderer";
import formStyles from "../../formStyles";
import MESSAGES from "../../../../../appMessages";
import RMAXMaintenance from "../../../../common/RMAXMaintenance";

class NotificationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notification: this.readNotificationData(this.props.data),
            error:{
                type: null,
                message: null,
                linkUrl: null,
                linkLabel:null
            }
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.data !== prevProps.data){
            this.setState({
                notification: this.readNotificationData(this.props.data)
            })
        }
    }

    readNotificationData = (notificationdata) => {
        if(notificationdata){
            if(notificationdata.type === notificationConstant.TYPE_MAINTENANCE){
                return { ... notificationdata, message: this.convertHtmltoString(notificationdata.message)}
            }
            return notificationdata;
        }
        return this.getDefaultNotificationValues();
    }

    getDefaultNotificationValues = () => {
        return ({
            type: '',
            message: '',
            linkLabel:'',
            linkUrl:'',
            isClosable: true
        })
    }

    updateNotificationData = (field, value) => {
        const isMaintenanceNotification = field === "type" && value === notificationConstant.TYPE_MAINTENANCE;
        this.setState(state => ({
            notification:{
                ...state.notification,
                [field]: value,
                isClosable: isMaintenanceNotification ? false: state.notification.isClosable
            },
            error:{
                ...state.error,
                [field]: null
            }
        }))
    }


    changeNotificationType = (value) => {
        this.updateNotificationData('type', value ? value.label: '');
    }

    clearField = (field) => (value) => {
       this.updateNotificationData(field,'');
    }

    getFieldIcon = field =>{
        const { classes } = this.props;
        if(this.state.notification[field]){
            return <InputAdornment ><Cancel  onClick={this.clearField(field)} classes={{root: classes.iconClass}}/></InputAdornment>
        } else if(this.state.error[field]){
            return <InputAdornment><ErrorIcon color="error" /></InputAdornment>
        }
        return null;
    }

    // get common props for all the text fields
    getTextFieldDefaultProps = (fieldName, classes) => {
        return {
                id: fieldName,
                autoComplete:"off",
                classes:{
                    root: classes.fieldRoot
                },
                InputLabelProps:{
                    classes:{
                        root: classes.label
                    }
                },
                InputProps :{
                    classes:{
                        root: classes.inputRoot,
                        input: `${classes.inputField} customScroll`,
                        notchedOutline: classes.notchedOutline,
                        focused: classes.inputFocused,
                        disabled:classes.inputDisabled,
                        error: classes.inputError,
                        inputMultiline: classes.multilineInput
                    },
                    endAdornment: this.getFieldIcon(fieldName)
                },
                value :this.state.notification[fieldName],
                onChange : (event) => this.updateNotificationData(fieldName, event && event.target ? event.target.value : ""),
                margin : "normal",
                variant : "outlined",
                error : Boolean(this.state.error[fieldName]),
                helperText : this.state.error[fieldName]
            }
    }

    updateNotification = (event) => {
        event.preventDefault();
        if(this.isValidInput()){
            const  notification  = {...this.state.notification};
            const isMaintenanceNotification = notification.type === notificationConstant.TYPE_MAINTENANCE;
            notification.message = isMaintenanceNotification ? this.convertStringToHtml(notification.message) : this.trimSpace(notification.message);
            notification.linkLabel = this.trimSpace(notification.linkLabel);
            notification.linkUrl = this.trimSpace(notification.linkUrl);
            this.props.onAdd(notification);
        }
    }

    isValidUrl = (url) => {
        const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/igm;
        return regex.test(url);
    }

    isValidInput = () => {
        let error = {};
        const { notification } = this.state;
        if(!notification.type){
            error.type = '* Required'
        }
        if(!notification.message){
            error.message = '* Required'
        }
        if(notification.linkUrl && !notification.linkLabel){
            error.linkLabel = '* Required'
        }
        // if(notification.linkLabel && !notification.linkUrl){
        //     error.linkUrl = '* Required'
        // }
        if(notification.linkUrl && !this.isValidUrl(notification.linkUrl)){
            error.linkUrl = '* Invalid URL'
        }
        let allowUpdate = Object.values(error).length === 0;
        if(allowUpdate ){
            notification.message = this.trimSpace(notification.message)
            notification.linkLabel = this.trimSpace(notification.linkLabel)
            notification.linkUrl = this.trimSpace(notification.linkUrl)
            // check if values are changed
            if(this.props.data && isEqual(this.readNotificationData(notification), this.readNotificationData(this.props.data))){
                this.props.enqueueSnackbar(MESSAGES.NOTIFICATION.NO_CHANGES, {variant: "info"});
                allowUpdate = false;
            }
        }
        this.setState({
            error
        });
        return allowUpdate;
    }

    trimSpace = value => {
        if(value !== null){
            value = value.trim();
        }
        return value;
    }


    toggleIsClosable = () => {
        this.setState(state => ({
            notification:{
                ...state.notification,
                isClosable: !state.notification.isClosable
            }
        }))
    }

    convertStringToHtml = (string) => {
        const htmlstring = string.replace(/(\r\n|\n|\r)/g, "<br />")         // replace new line with "<br />" to indicate single paragraph
                                  .replace(/(<br \/>){2,}/g, "\n")            // min 2 <br /> indicates new paragraph
                                  .split("\n")                                
                                  .filter(Boolean)                             // get array of paragraph string  
                                  .map(paragraphContent => `<p>${paragraphContent}</p>`)           // wrap each paragraph content with <p> tag
                                  .join("");                                   // join to form single html string
        return this.trimSpace(htmlstring);
    }

    convertHtmltoString = (htmlString) => {
        const string = htmlString.replace(/(<p>)/g,"")
                                 .replace(/(<\/p>)/g, "\n\n")                      // replace paragraph with double "\n" to indicate more space
                                 .replace(/(<br \/>)/g, "\n")                      // replace <br /> with "\n" to indicate next line
        return this.trimSpace(string);
    }

    render() {
        const { classes } = this.props;
        const { notification, error }= this.state;
        const newNotification = !this.props.data;
        const isMaintenanceNotification = notification.type === notificationConstant.TYPE_MAINTENANCE;
        return (
           <div>
                    <h4 className={classes.title}>{ newNotification ? 'Create Notification' : 'Update  Notification' }</h4>
                    <form className={classes.form} noValidate onSubmit={this.updateNotification}>
                        <div className = {classes.flexRow} >
                            <Select
                                textFieldProps= {{
                                    id: "notificationType",
                                    label: "Type",
                                    variant: "outlined",
                                    helperText : error.type
                                }}
                                value={notification.type}
                                error ={Boolean(error.type)}
                                onChange={this.changeNotificationType}
                                data={notificationConstant.TYPES}
                            />
                        </div>
                         <div className={classes.flexRow}>
                             <TextField
                                multiline
                                rows={isMaintenanceNotification? 8 : 2}
                                {...this.getTextFieldDefaultProps("message", classes)}
                                label = "Message (450 characters max)"
                                value = {notification.message || ""}
                                id="notificationMessage"
                                inputProps={{
                                    maxlength: 450
                                }}
                            />
                        </div>
                        { !isMaintenanceNotification && (
                            <React.Fragment>
                                <div className = { classes.flexRow} >
                                    <TextField
                                        {...this.getTextFieldDefaultProps("linkLabel", classes)}
                                        label = "Link label"
                                        value = {notification.linkLabel || ""}
                                        id="notificationLinkLabel"
                                        inputProps={{
                                            maxlength: 50
                                        }}
                                    />
                                </div>
                                <div className = { classes.flexRow} >
                                    <TextField
                                        multiline
                                        rows={2}
                                        {...this.getTextFieldDefaultProps("linkUrl", classes)}
                                        label = "Link"
                                        value = {notification.linkUrl || ""}
                                        placeholder="https://help.routemax.com"
                                        id="notificationLinkUrl"
                                        inputProps={{
                                            maxlength: 500
                                        }}
                                    />
                                </div>
                                <div className={classes.flexRow}>
                                    <div className={classes.toggleContainer}>
                                        <label className={classes.toggleLabel}>Allow close</label>
                                        <ToggleRenderer value={notification.isClosable} onChange={this.toggleIsClosable} id="notificationAllowClose"/>
                                        <span> { notification.isClosable ? 'Yes' : 'No' } </span>
                                    </div>
                                </div>
                            </React.Fragment>
                         )}
                        
                        <div className={classes.actionContainer}>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="medium"
                                disabled={this.props.updateInProgress}
                                onClick={this.props.onClose}
                                classes={{root: classes.actionButton, disabled: classes.actionOutlineDisabled}}
                                id="notificationCloseButton"
                            >
                                    Close
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                type="submit"
                                disabled={this.props.updateInProgress}
                                classes={{root: classes.actionButton, disabled: classes.actionButtonDisabled}}
                                id="notificationSubmit"
                            >
                                { this.props.updateInProgress ?
                                    <CircularProgress  size={16} classes={{root: classes.circularProgress}} />
                                    :  newNotification ? "Add Notification" : "Update Notification" }
                            </Button>
                        </div>
                    </form>

                    { this.state.errorMessage &&
                        <div className={classes.errorMessage}>{this.state.errorMessage}</div>
                    }
        </div>
        )
    }
}

export default compose(withStyles(formStyles),withSnackbar)(NotificationForm);